module.exports = __webpack_public_path__ + "img/customNum6.41b422cf.png";